import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-map-privacy-banner',
  templateUrl: './map-privacy-banner.component.html',
  styleUrls: ['./map-privacy-banner.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapPrivacyBannerComponent {
  customizeSettings(event: MouseEvent) {
    event.stopPropagation();

    const cookieSettingsButton = document.querySelector<HTMLButtonElement>(
      'button.ot-floating-button__open'
    );
    cookieSettingsButton?.click();
  }
}
